import { message } from "antd";
import endpoints from "../utils/endpoints";
import { removeEmpty } from "../utils/objectUtils";
import userStatus from "../utils/userStatus";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";

export async function getUsersList(params: any) {
    let res = {
        count: 0,
        list:[{
            id: 1,
            name: "",
            affiliation: "",
            company: "",
            email: "",
            phone: "",
            status: "",
            canEdit: "Yes",
        }],
        page: null,
        perpage:0
    }
    if(params) {
      params = removeEmpty(params)
    }
    await Api.get(endpoints.getUserList, {params}).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get data from servers')
    })
    return res
}

export async function createOrUpdateUser(payload: any) {
  let validated = false
  await Api.post(endpoints.createOrUpdateUser, payload).then((response) => {
    if(response.status === 200) {
      if(response.data.error || response.data.return === "false") {
        notificationError(`${response.data.message}`)
      } else {
        validated = true
        if(payload.id) return notificationSucces('User was successfully updated')
        notificationSucces('User was successfully created')
      }
    } else {
      if(payload.id) return notificationSucces('User was not updated')
      notificationError('User was not created')
    }
  }).catch((err: string) => {
    if(payload.id) return notificationSucces('User was not updated')
    notificationError('User was not created')
  })
  return validated
}

export async function getUserById (params: any) {
  let res = {
    id: '',
    affiliationLevel: 'manufacturer',
    firstName: '',
    middleName: '',
    lastName: '',
    status: userStatus.active,
    email: '',
    encryptedPassword: '',
    roles: ['0'],
    company: '',
    locationId: null,
    charityId: null,
    distributorId: null,
    phone: '',
  };
  await Api.get(endpoints.getUserById, {params}).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })
  
  return res
}


export async function changeUserStatusById(params: any) {

  await Api.get(endpoints.changeUserStatusById, {params}).then((response) => {
    if(response.status === 200 && response.data) {
        if(response.data.error) {
            notificationError(`${response.data.message}`)
        } else {
            notificationSucces('Status changed successfully')
        }
    } else {
      notificationError('Status not changed')
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })
}

export async function getAffiliationOptions() {
  let res: {name: string, value: string}[] = []
  await Api.get(endpoints.getAffiliationOptions).then((response) => {
    if(response.status === 200 && response.data) {
        if(response.data.error) {
            notificationError(`${response.data.message}`)
        } else {
            res = response.data
        }
    } else {
      notificationError('Could not get affiliation options')
    }
  }).catch((err: string) => {
    notificationError('Could not get affiliation options')
  })
  return res
}